import { CareersInquiryMap } from "./hfdicareersinquiryAction";

const initialState = {
  isLoading: false,
  CareersInquiryList: {},
  refreshCareersInquiryList: true,
  searchBy: "",
  countries: [],
  searchText: "",
  skip: 0,
  limit: 10,
  selectedCareersInquiry: {},
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CareersInquiryMap.GET_ALL_HFDI_CAREERS_INQ_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CareersInquiryMap.GET_ALL_HFDI_CAREERS_INQ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        CareersInquiryList: action.payload,
        refreshCareersInquiryList: false,
      };
    }
    case CareersInquiryMap.GET_ALL_HFDI_CAREERS_INQ_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshCareersInquiryList: false,
      };
    }

    case CareersInquiryMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
        refreshCareersInquiryList: true,
      };
    }
    case CareersInquiryMap.SET_HFDI_CAREERS_INQ_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshCareersInquiryList: true,
      };
    }
    case CareersInquiryMap.GET_HFDI_CAREERS_INQ_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CareersInquiryMap.GET_HFDI_CAREERS_INQ_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        CareersInquiryList: action.payload,
        refreshCareersInquiryList: false,
      };
    }
    case CareersInquiryMap.GET_HFDI_CAREERS_INQ_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshCareersInquiryList: false,
      };
    }
    default:
      return { ...state };
  }
};
